"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconFilterNew = function IconFilterNew(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    className: (0, _classnames.default)('Icon', 'IconFilterNew', className),
    style: style
  }, _react.default.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    "fill-rule": "evenodd",
    d: "M8.714 11a.5.5 0 0 1 .5.5v.75h5a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75h-5v.75a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.75h-4.5a.75.75 0 0 1-.743-.648L2.964 13a.75.75 0 0 1 .75-.75h4.5v-.75a.5.5 0 0 1 .41-.492zm-4-5a.5.5 0 0 1 .5.5v.75h9a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75h-9v.75a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.75h-.5a.75.75 0 0 1-.743-.648L2.964 8a.75.75 0 0 1 .75-.75h.5V6.5a.5.5 0 0 1 .41-.492zm8-5a.5.5 0 0 1 .5.5v.7h1a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75h-1v.8a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.8h-8.5a.75.75 0 0 1-.743-.648l-.007-.102a.75.75 0 0 1 .75-.75h8.5v-.7a.5.5 0 0 1 .41-.492z"
  }));
};

var _default = IconFilterNew;
exports.default = _default;